// Tooltips
export const STATUT_TOOLTIP: string = `
  <p><strong>SurPlancher</strong> : Produit présent sur le plancher.</p>
  <p><strong>VersPL</strong> : Produit absent du plancher.</p>
  <ul>
    <li><strong>N/Réservé</strong> : Transfert impossible car aucune réservation plancher (I-T-E).</li>
    <li><strong>En suspens</strong> : Transfert impossible mais réservation plancher (I-T-E) créée.</li>
    <li><strong>Rsv Planché</strong> : Transfert possible avec réservation plancher (I-T-E).</li>
    <li><strong>Libéré #</strong> : Transfert attend que le produit # soit vendu/enlevé du plancher.</li>
    <li><strong>Trsf # -> #</strong> : Produit en transfert de l'entrepôt vers le magasin.</li>
    <li><strong>BinPlancher</strong> : Produit en magasin dans la bin "Plancher"</li>
    <li><strong>Backstore</strong> : Produit en magasin rangé dans le backstore</strong></li>
  </ul>
  <p><strong>SortirPL</strong> : Produit présent sur le plancher qui doit être vendu.</p>
  <ul>
    <li><strong>Vendu</strong> : Produit présent sur le plancher qui a une réservation plancher est trouvée.</li>
  </ul>
  <p><strong>Inactif</strong> : Produit a été sorti du plancher.</p>
`;

export const P2_JOUR_TOOLTIP: string = "Moyenne des ventes par jour par pied² depuis la date de début. Si pi² = 0 alors moyenne des ventes par jour depuis la date de début";

export const DATE_DEBUT_TOOLTIP: string = "Date où le produit est apparu sur le plancher";

export const DATE_FIN_TOOLTIP: string = "Date où le produit est disparu du plancher";

export const DATE_ENTREE_TOOLTIP: string = "Date demandée pour que le démo plancher soit transféré vers le plancher";

export const DATE_SORTIE_TOOLTIP: string = "Date demandée pour que le démo plancher soit transféré hors du plancher";